export const formatNumber = (value: number) =>
  Number.isInteger(value) ? value.toString() : value.toFixed(1);
